/*
 * 功能名称: 部门工作基准字典
 * 创 建 人: lichunyang
 * 日    期: 2025年7月25日 11:33
 */
import { NewviewOaBaseApi } from './NewviewOaBaseApi'

export class PerformanceRecordIndicatorApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'performance-record-indicator'
  }

  constructor() {
        super();
        this.addHeader("tableName", 'performance_record_indicator');
    } 
}
